export default __webpack_public_path__ + "static/media/229.493b0a7c.png";